import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgForm } from "@angular/forms";
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe, DecimalPipe } from "@angular/common";
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { VoucherService } from "./shared/voucher.service";
import { Ledgerentries } from "../../master/ledger/shared/ledgerentries.model";
import { LedgerService } from "../../master/ledger/shared/ledger.service";
import { FormControl } from '@angular/forms';
import { debounceTime } from "rxjs/operators";
import { CommonmastersService } from "../../commonmasters/commonmasters.service";

@Component({
  selector: 'app-voucher',
  templateUrl: './voucher.component.html',
  styleUrls: ['./voucher.component.css']
})

// @ViewChild("myinput") myInputField: ElementRef;

export class VoucherComponent implements OnInit {

  AddButtonText: string;
  ErrorText: string;
  displayedColumns: string[] = ['Id', 'Particulars', 'Debit', 'Credit', 'Balance', 'New'];
  dataSourceList = new MatTableDataSource<any>();
 @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  divDetails: boolean;
  ParentVoucherNo: number;
  VoucherTypeList: any[] = [];
  LedgerList: any = [];

  public ledgerArray: Array<any> = [];
  public newLedger: any = { Id: 0, LedgerId: null, Particulars: null, EntryType: null, Debit: 0.0, Credit: 0.0, Balance: 0.0 };

  searchTerm: FormControl = new FormControl();
  btnvisibility: boolean = true;

  totalDebit: number=0.0;
  totalCredit: number=0.0;  

  constructor(private router: Router, private activatedRoute: ActivatedRoute,
    public voucherService: VoucherService, private datePipe: DatePipe,
    private ledgerService: LedgerService, private commonmastersService: CommonmastersService) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(param => {
      this.ParentVoucherNo = + param['Id'];  //Parent voucher Id
    });

    this.GetVoucherTypeList();

    this.searchTerm.valueChanges.pipe(debounceTime(700)).subscribe(
      term => {
        if (term != undefined) {
          this.ledgerService.FetchLedgerByNames(term).subscribe(
            data => {
              this.LedgerList = data as any[];
            }
          )
        }
      })

    this.resetForm();
    this.GetAutogeneratedNumber();

    if (Number.isNaN(this.ParentVoucherNo)) {
      this.voucherService.selectedVoucher.Id = 0;
      this.voucherService.selectedVoucher.Flag = 1;
      this.voucherService.selectedVoucher.IsActive = 1;
      this.AddButtonText = "Save";
      this.voucherService.selectedVoucher.Narration = "Rcvd: \n Towards:  \n Bill No:";
    }
    else {
      this.voucherService.selectedVoucher.TransactionId = +this.ParentVoucherNo;
      this.voucherService.selectedVoucher.Flag = 2;
      this.GetVoucherById(); 
      this.GetLedgerEntriesById();     
      this.AddButtonText = "Edit & Save";
    }
    
  }

  resetForm(form?: NgForm) {
    if (form != null)
      form.reset();

    this.voucherService.selectedVoucher = {
      Id: null,
      VoucherNumber: null,
      VoucherTypeId: 1,
      VoucherAmount: 0,
      VoucherTotalDebit: 0.0,
      VoucherTotalCredit: 0.0,
      Narration: null,
      ApprovalStatusId: 0,
      ReceiptTypeId: 0,
      ListByApprovalStatus:0,
      // VoucherDate: null, new Date( Date.parse( this.datePipe.transform( staff.FromDate,"yyyy-MM-dd")))
      // VoucherDate: new Date(Date.parse(this.datePipe.transform(new Date(), "yyyy-MM-dd"))),
      // VoucherDate: new Date(localStorage.getItem("CreatedDate")),

      ToDate: null,
      FromDate: null,
      ReportName: null,
      VoucherDate: JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"],
      EmployeeId: null,
      BranchId: null,
      CompanyId: null,
      SaasId: null,
      CreatedDate:JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"],
      ModifiedDate: JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"],
      IsActive: 0,
      Flag: 0,
      TransactionId:0,
      EmployeeBranchId:0,
      CentreId:0,

      LedgerentriesList: [{
        Id: 0,
        TransactionId: 0,
        LedgerId: 0,
        Particulars: null,
        EntryType: null,
        Amount: 0,
        Remarks: null,
        PersonId: 0,
        CostCentreId: 0,
        CreatedDate: null,
        FromDate: null,
        ToDate: null,
        VoucherTypeId: null,
        Isopening : true,
        IsDayClose : false,
        TotalAmount : 0.0,
        LedgerName : null
      }],

      Ledgerentries: {
        Id: 0,
        TransactionId: 0,
        LedgerId: 0,
        Particulars: null,
        EntryType: null,
        Amount: 0,
        Remarks: null,
        PersonId: 0,
        CostCentreId: 0,
        CreatedDate: null,
        FromDate: null,
        ToDate: null,
        VoucherTypeId: null,
        Isopening : true,
        IsDayClose : false,
        TotalAmount : 0.0,
        LedgerName : null
      }
    }
  }

  GetAutogeneratedNumber(): any {
    const myAutoGeneratedId = this.commonmastersService.FetchAutogeneratedNumber()
      .toPromise()
      .then(res => {
        this.voucherService.selectedVoucher.VoucherNumber = res[0].AutoGeneratedId;
        return Promise.resolve(res[0].AutoGeneratedId);
      })
      .catch(err => { console.log(err) });
  }

  public onSubmit(form: NgForm) {

    if(this.totalCredit != this.totalDebit){
      this.ErrorText = "Debit and Credit should be equal";
      return;
    }

    this.voucherService.selectedVoucher.LedgerentriesList = [];
    for (let i = 0; i < this.ledgerArray.length; i++) {

      this.voucherService.selectedVoucher.Ledgerentries = new Ledgerentries();
      this.voucherService.selectedVoucher.Ledgerentries.Id = this.ledgerArray[i].Id;     
      this.voucherService.selectedVoucher.Ledgerentries.LedgerId = this.ledgerArray[i].LedgerId;
      this.voucherService.selectedVoucher.Ledgerentries.EntryType = this.ledgerArray[i].EntryType;
      this.voucherService.selectedVoucher.Ledgerentries.Particulars = this.ledgerArray[i].Particulars;

      if ( this.ledgerArray[i].Debit != null) {
        // this.voucherService.selectedVoucher.Ledgerentries.EntryType = "D";
        this.voucherService.selectedVoucher.Ledgerentries.Amount = + this.ledgerArray[i].Debit;
      }
      else {
        // this.voucherService.selectedVoucher.Ledgerentries.EntryType = "C";
        this.voucherService.selectedVoucher.Ledgerentries.Amount = + this.ledgerArray[i].Credit;
      }
      this.voucherService.selectedVoucher.Ledgerentries.CreatedDate = form.value.VoucherDate;
      this.voucherService.selectedVoucher.Ledgerentries.TransactionId = form.value.VoucherNumber;
      this.voucherService.selectedVoucher.Ledgerentries.Remarks = "Voucher Entry";
      this.voucherService.selectedVoucher.LedgerentriesList.push(this.voucherService.selectedVoucher.Ledgerentries);
      this.voucherService.selectedVoucher.Ledgerentries = null;
    }

    this.voucherService.selectedVoucher.Id = form.value.Id;
    this.voucherService.selectedVoucher.VoucherNumber = form.value.VoucherNumber;
    this.voucherService.selectedVoucher.VoucherTypeId = form.value.VoucherTypeId;
    this.voucherService.selectedVoucher.VoucherAmount = this.totalCredit; //form.value.VoucherTotalCredit;
    this.voucherService.selectedVoucher.VoucherTotalDebit = form.value.VoucherTotalDebit;
    this.voucherService.selectedVoucher.VoucherTotalCredit = form.value.VoucherTotalCredit;
    this.voucherService.selectedVoucher.Narration = form.value.Narration;
    this.voucherService.selectedVoucher.VoucherDate = form.value.VoucherDate;
    this.voucherService.selectedVoucher.ApprovalStatusId = form.value.ApprovalStatusId;
    this.voucherService.selectedVoucher.ReceiptTypeId = form.value.VoucherTypeId;//1; // need to change
    // var isoDate = new Date().toISOString()

    this.voucherService.IUDVoucher(this.voucherService.selectedVoucher)
      .toPromise()
      .then(data => {
        this.router.navigate(['/voucherlist']);
      })
      .catch(err => { console.log(err) });

  }

  GetVoucherById() {
    if (!Number.isNaN(this.ParentVoucherNo)) {
      this.voucherService.selectedVoucher.Id = this.ParentVoucherNo;
      this.voucherService.FetchVoucherById(this.voucherService.selectedVoucher).subscribe(data => {

        this.voucherService.selectedVoucher = data;
        this.voucherService.selectedVoucher.Flag = 2;
        this.voucherService.selectedVoucher.Narration = data.Narration;
      })
    }
  }

  GetLedgerEntriesById() {
   
    if (!Number.isNaN(this.ParentVoucherNo)) {

      this.voucherService.selectedVoucher.TransactionId = this.ParentVoucherNo;
      this.voucherService.FetchLedgerEntriesById(this.voucherService.selectedVoucher).subscribe(data => {

        this.newLedger = { Id: this.newLedger.Id + 1, LedgerId: null, Particulars: null, EntryType: null, Debit: null, Credit: null, Balance: null };

        for (let i = 0; i < data.length; i++) {
          this.newLedger.Id =+ i;
          this.newLedger.LedgerId =+ data[i].LedgerId;
          this.newLedger.EntryType = data[i].EntryType;
          this.newLedger.TransactionId = data[i].TransactionId;
          this.newLedger.Particulars = data[i].LedgerName;

          if ( data[i].EntryType != 'C') {
            this.newLedger.Debit = + data[i].Amount;
            // this.voucherService.selectedVoucher.VoucherTotalDebit = this.voucherService.selectedVoucher.VoucherTotalDebit+ data[i].Amount;  
            this.totalDebit = this.totalDebit + parseInt(data[i].Amount);
          }
          else {
            this.newLedger.Credit = + data[i].Amount;
            //  this.voucherService.selectedVoucher.VoucherTotalCredit =+ data[i].Amount;
             this.totalCredit = this.totalCredit + parseInt(data[i].Amount);
          }
          
          this.ledgerArray.push(this.newLedger);
          this.newLedger = { Id: this.newLedger.Id + 1, LedgerId: null, Particulars: null, EntryType: null, Debit: null, Credit: null, Balance: null };
        }
      })
    }
  }

  GetVoucherTypeList() {
    this.voucherService.GetVoucherTypeList().subscribe(data => {
      this.VoucherTypeList = data;
    })
  }

  // @ViewChild("newLedgerCredit") newLedgerCredit: ElementRef;
  // ngAfterViewInit() {
  //   this.newLedger.Debit.nativeElement.focus();
  // }

  addFieldValue(): void {

    if ((this.newLedger.LedgerId != null && this.newLedger.Debit != null) ||
          (this.newLedger.LedgerId != null && this.newLedger.Credit != null)) {

      // handling EntryType based on the paymentType
      if (this.newLedger.LedgerId != null && this.newLedger.Debit != null){
        this.newLedger.EntryType = 'D';
      }   
      
      if(this.newLedger.LedgerId != null && this.newLedger.Credit != null){
        this.newLedger.EntryType = 'C';
      }

      this.totalCredit  = 0.0;
      this.totalDebit  = 0.0;

      //this.newLedger.LedgerId, currently hold the ledger name! 
      this.newLedger.Particulars = this.newLedger.LedgerId;
      // here we changing the ledger name To Ledger Id
      this.newLedger.LedgerId = this.LedgerList.find(item => item.SubLedgerName == this.newLedger.LedgerId).Id      
      this.ledgerArray.push(this.newLedger);

      // calculating total debit and credit
      this.ledgerArray.forEach(ledgerAmount => {
        
        if (ledgerAmount.Credit != 0 && ledgerAmount.Credit != null) {
          this.totalCredit = this.totalCredit + parseInt(ledgerAmount.Credit);
        }
        if (ledgerAmount.Debit != 0 && ledgerAmount.Debit != null) {
          this.totalDebit = this.totalDebit + parseInt(ledgerAmount.Debit);
        }
      });

      this.newLedger = { Id: this.newLedger.Id + 1, LedgerId: null, Particulars: null, EntryType: null, Debit: null, Credit: null, Balance: null };

      // diabling the button which is not equal the credit and debit amount
      if(this.totalCredit != this.totalDebit){        
        this.btnvisibility =true;
      }
    }
  }

  deleteFieldValue(index) {

    if (this.ledgerArray[index].Debit != null) {
      this.totalDebit =  this.totalDebit - JSON.parse(this.ledgerArray[index].Debit);
      // this.voucherService.selectedVoucher.VoucherTotalDebit = new Number(this.voucherService.selectedVoucher.VoucherTotalDebit).valueOf() - JSON.parse(this.ledgerArray[index].Debit);
    }
    else {
      this.totalCredit = this.totalCredit - JSON.parse(this.ledgerArray[index].Credit);
      // this.voucherService.selectedVoucher.VoucherTotalCredit = new Number(this.voucherService.selectedVoucher.VoucherTotalCredit).valueOf() - JSON.parse(this.ledgerArray[index].Credit);
    }

    this.ledgerArray.splice(index, 1);
    this.newLedger = { Id: this.newLedger.Id - 1, Particulars: null, Debit: null, Credit: null, Balance: null };
  }

  /// select The auto Ledger by voucherType
  getAutoLedger(voucherTypeId: Number) {

    this.voucherService.FetchAutoLedgerById(voucherTypeId)
      .toPromise()
      .then(data => {

        this.newLedger = {
          Id: this.newLedger.Id + 1,
          LedgerId: data.LedgerId,
          Particulars: data.LedgerName,
          EntryType: data.EntryType,

          // here we managing the double entry system. 
          Debit: this.voucherService.selectedVoucher.VoucherTotalCredit,  //  changing debit as credit here,very important 
          Credit: this.voucherService.selectedVoucher.VoucherTotalDebit, //  changing credit as debit here,very important           
          Balance: data.TotalAmount
        };

        if (this.ledgerArray.find(item => item.LedgerId == data.LedgerId)) {

          if (this.voucherService.selectedVoucher.VoucherTypeId == 1) {
            this.ledgerArray.find(item => item.LedgerId == data.LedgerId).Debit = + JSON.parse(this.newLedger.Debit);
            this.ledgerArray.find(item => item.LedgerId == data.LedgerId).Credit = + 0
          }
          else if (this.voucherService.selectedVoucher.VoucherTypeId == 2) {
            this.ledgerArray.find(item => item.LedgerId == data.LedgerId).Debit = + 0;
            this.ledgerArray.find(item => item.LedgerId == data.LedgerId).Credit = + JSON.parse(this.newLedger.Credit);
          }
          if (this.voucherService.selectedVoucher.VoucherTypeId == 3) {
            this.ledgerArray.find(item => item.LedgerId == data.LedgerId).Debit = + 0;
            this.ledgerArray.find(item => item.LedgerId == data.LedgerId).Credit = + JSON.parse(this.newLedger.Credit);
          }
          else if (this.voucherService.selectedVoucher.VoucherTypeId == 4) {
            this.ledgerArray.find(item => item.LedgerId == data.LedgerId).Debit = + JSON.parse(this.newLedger.Debit);
            this.ledgerArray.find(item => item.LedgerId == data.LedgerId).Credit = + 0
          }
        }
        else {
          this.ledgerArray.push(this.newLedger);
        }
        // handling EntryType based on the VoucherType
        if (this.voucherService.selectedVoucher.VoucherTypeId == 1) {
          this.voucherService.selectedVoucher.VoucherTotalDebit = + JSON.parse(this.newLedger.Debit); // actualy it is Debit based on double entry
        }
        else if (this.voucherService.selectedVoucher.VoucherTypeId == 2) {
          this.voucherService.selectedVoucher.VoucherTotalCredit = + JSON.parse(this.newLedger.Credit);  // actualy it is Credit bsed on double entry
        }
        else if (this.voucherService.selectedVoucher.VoucherTypeId == 3) {
          this.voucherService.selectedVoucher.VoucherTotalCredit = + JSON.parse(this.newLedger.Credit);
        }
        else if (this.voucherService.selectedVoucher.VoucherTypeId == 4) {
          this.voucherService.selectedVoucher.VoucherTotalDebit = + JSON.parse(this.newLedger.Debit);
        }

        //clearing the added values   
        this.newLedger = { Id: this.newLedger.Id + 1, LedgerId: null, Particulars: null, EntryType: null, Debit: null, Credit: null, Balance: null };
      })
      .catch(err => { console.log(err) });
  }

  // clear the ledgers already added.
  VoucherChange(CentreId: any): void {

    this.ledgerArray = [];
    this.voucherService.selectedVoucher.VoucherTotalDebit = 0.0;
    this.voucherService.selectedVoucher.VoucherTotalCredit = 0.0;
    this.newLedger = { Id: this.newLedger.Id + 1, LedgerId: null, Particulars: null, EntryType: null, Debit: null, Credit: null, Balance: null };
  }

}